import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import zipcelx, { ZipCelXConfig } from "zipcelx";
import { Fare, FarePriceBreakdown } from "../Models";
import { requestPrice } from "../utils";
import { generateFaresExport } from "../utils/exporter";

export default (props: { fares: Fare[]; onClose: () => any }) => {
  let [priceBreakdowns, setPriceBreakdowns] = useState<FarePriceBreakdown[]>(
    []
  );
  let [loading, setLoading] = useState<boolean>(false);
  let [priceCount, setPriceCount] = useState<number>(0);
  let [exportContent, setExportContent] = useState<ZipCelXConfig | undefined>(
    undefined
  );
  let [shouldStop, setShouldStop] = useState<boolean>(false);

  const getPrices = async () => {
    if (loading) {
      return;
    }
    setLoading(true);

    const length = props.fares.length;
    for (let i = 0; i < length; i++) {
      if (shouldStop) {
        setShouldStop(false);
        setLoading(false);
      }
      const fare = props.fares[i];
      const pbd = await requestPrice(fare);

      if (pbd) {
        let prices = priceBreakdowns;
        prices.push(pbd);
        setPriceBreakdowns(prices);
        setPriceCount(prices.length);
      }
    }
    setLoading(false);

    const exp = await generateFaresExport(priceBreakdowns);
    setExportContent(exp);
  };

  useEffect(() => {
    if (!priceBreakdowns.length) {
      getPrices();
    }
  });

  const onClose = () => {
    setShouldStop(true);
    props.onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      open={true}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <DialogTitle>Export des tarifs</DialogTitle>
      <DialogContent>
        {!exportContent && (
          <>
            <DialogContentText>
              Calcul des tarifs en cours 👷: <br />
              {priceCount} / {props.fares.length}
            </DialogContentText>
            <LinearProgress
              variant="determinate"
              value={(priceCount / (props.fares.length || 1)) * 100}
            />
          </>
        )}
        {exportContent && (
          <>
            <DialogContentText>Calculs terminés 🎉</DialogContentText>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {loading && "Annuler"}
          {!loading && "Fermer"}
        </Button>
        {exportContent && (
          <>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => {
                zipcelx(exportContent!);
              }}
            >
              Telecharger le fichier
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
